// @ts-nocheck
import actionTypes from './developerToolBarActionTypes';

const override = (overrides) => ({ type: actionTypes.OVERRIDE, overrides });

export { override };
